function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 9.875,
  y: 6.43767,
  width: 11.8125,
  height: 12.625,
  rx: 1,
  fill: "#2E89E1",
  stroke: "#2E89E1",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5625 11.1252L21.0625 11.1252",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4 6.4853C4 5.49958 4.71819 4.66085 5.69216 4.50913L13.0722 3.35951C14.2848 3.1706 15.38 4.10838 15.38 5.33567V20.1643C15.38 21.3916 14.2848 22.3294 13.0722 22.1405L5.69216 20.9909C4.71819 20.8391 4 20.0004 4 19.0147V6.4853Z",
  fill: "#2E89E1",
  stroke: "white",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42383 11.5582L8.42383 11.125C8.42383 10.2276 9.15137 9.50005 10.0488 9.50005V9.50005C10.9463 9.50005 11.6738 10.2276 11.6738 11.125L11.6738 11.9913C11.6738 12.8888 10.9463 13.6163 10.0488 13.6163V13.6163",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0488 12.2435V12.2435C9.15137 12.2435 8.42383 12.9711 8.42383 13.8685L8.42383 14.7348C8.42383 15.6322 9.15137 16.3598 10.0488 16.3598V16.3598C10.9463 16.3598 11.6738 15.6322 11.6738 14.7348L11.6738 14.3016",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.25,
  cy: 7.87527,
  rx: 0.8125,
  ry: 0.8125,
  fill: "white"
});

var SvgHtmlHover = function SvgHtmlHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHtmlHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/htmlHover.30744fc9.svg";
export { ForwardRef as ReactComponent };